<template>
    <div class="animated fadeIn">
        <BasicHeading title="New Quality Control Sample">
            <template #right-content>
                <HeaderButtonGroup :button_config="button_group"></HeaderButtonGroup>
            </template>
        </BasicHeading>
        <PermissionAlertGate :permissions="'add quality control'">
            <template #gated-content>
                <quality-control-add-form
                    :sample_type_id="sample_type_id"
                    :test_task="test_task"
                    :prep_task="prep_task"
                    @submit="submitForm"
                ></quality-control-add-form>
            </template>
        </PermissionAlertGate>
    </div>
</template>
<script>
import Vue from 'vue';
import VueNotifications from "vue-notifications";
import QualityControlAddForm from '@/components/lab/qualitycontrol/QualityControlAddForm';
import BasicHeading from '@/components/shared/BasicHeading.vue';
import HeaderButtonGroup from '@/components/shared/headerbuttons/HeaderButtonGroup.vue';
import PermissionAlertGate from '@/components/permission/PermissionAlertGate.vue';
import { LabRepositoryFactory } from "@/repositories/lab/LabRepositoryFactory";
import { notificationOptions } from "@/shared/toast-notification-options";
import { qualityControlNotifications } from "@/shared/notifications";
import { getCollection } from "@/shared/fetch-utils";

const QualityControlRepository = LabRepositoryFactory.get("qualityControl");

Vue.use(VueNotifications, notificationOptions);

export default {
    name: "QualityControlAdd",
    components: {
        QualityControlAddForm,
        BasicHeading,
        HeaderButtonGroup,
        PermissionAlertGate
    },
    props: {
        sample_type_id: {
            type: String,
            default: null
        },
        test_task: {
            type: Object,
            default: () => null
        },
        prep_task: {
            type: Object,
            default: () => null
        }
    },
    data() {
        return {
            button_group: {
                buttons: [
                    {
                        icon: "fa-list",
                        linkto: "/quality-control",
                        title: "Quality Control list",
                    },
                ],
            },
        };
    },
    methods: {
        async submitForm(formData) {
            try {
                const payload = { ...formData }
                const { data } = await QualityControlRepository.create(payload);
                this.addSuccess();

                if (this.test_task) {
                    this.$router.push(`/test-workflows/${this.sample_type_id}/${this.test_task.test_process_id}/${this.test_task.id}`)
                } else if (this.prep_task) {
                    this.$router.push(`/prep-workflows/${this.sample_type_id}/${this.prep_task.prep_process_id}/${this.prep_task.id}`)
                } else {
                    this.$router.push(`/quality-control/${data.id}`);
                }
            } catch ({ response }) {
                const { status, data } = response.response;

                this.$bvToast.toast(`Code: ${status}. ${data.error}`, {
                    title: "Server Error",
                    variant: "danger",
                });
            }
        }
    },
    notifications: qualityControlNotifications,
};
</script>
